<template>
  <div class="rds-notifications-container">
    <div class="rds-notifications-overlay" v-on:tap.self="toggleNotifications"></div>
    <div class="rds-notifications">
      <div v-if="notificationsShow">
        <RdsNotification
          class="rds-notification"
          v-on:removeNotification="removeNotification"
          v-for="notification in filteredNotification"
          v-bind:key="notification.id"
          v-bind:notification="notification"
          v-swipe:onSwipe="{configs:[
        { handler: removeNotification, handlerArgs:notification, endTransitionDuration: 200 },
        { handler: removeNotification,handlerArgs:notification, endTransitionDuration: 200, direction: 'right' }
      ],}"
        ></RdsNotification>
      </div>
      <RdsNavettaReport v-if="navettaReportShow"></RdsNavettaReport>
    </div>
  </div>
</template>
<script>
import { eventBus } from '../services/EventBus';
import RdsNotification from '../components/RdsNotification';
import RdsNavettaReport from '../components/RdsNavettaReport';
import swipe from '../directives/swipe.new';
import store from '../stores';
import userService from '../services/User.service';
// const userNotifications = [
//   {
//     id: 0,
//     title: 'Manuela Meta',
//     body:
//       'Lorem ipsum dolor sit amet, consecte tur adipiscing elit. Quisque elementum laoreet leo, vitae imperdiet dui fermentum nec.'
//   },
//   {
//     id: 1,
//     title: 'Pinco Pallo',
//     body:
//       'Lorem ipsum dolor sit amet, consecte tur adipiscing elit. Quisque elementum laoreet leo, vitae imperdiet dui fermentum nec.'
//   }
// ];

export default {
  name: 'RdsNotifications',
  components: {
    RdsNotification,
    RdsNavettaReport
  },
  directives: {
    swipe
  },
  props: ['showNotifications', 'showNavettaReport'],
  data() {
    return {
      notifications: []
    };
  },
  computed: {
    filteredNotification() {
      return this.notifications.filter(n => {
        console.log(n);
        console.log('readed', userService.user.notificationsReaded);
        console.log('topics', userService.user.notificationsTopics);

        console.log(userService.user.notificationsReaded.indexOf(n.id));
        console.log(userService.user.notificationsTopics.indexOf(n.topic));
        return (
          n.author !== userService.user.id &&
          userService.user.notificationsReaded.indexOf(n.id) === -1 &&
          userService.user.notificationsTopics.indexOf(n.topic) !== -1
        );
      });
    },
    notificationsShow() {
      return this.showNotifications;
    },
    navettaReportShow() {
      return this.showNavettaReport;
    }
  },
  methods: {
    removeNotification(notification) {
      const user = userService.user;
      user.notificationsReaded.push(notification.id);
      userService.updateUser(user);
      this.notifications = this.notifications.filter(
        n => n.id !== notification.id
      );
      if (!this.notifications.length) {
        eventBus.$emit('hideNotifications');
      }
    },
    toggleNotifications: function() {
      eventBus.$emit('toggleNotifications');
      eventBus.$emit('hideNavettaReport');
    }
  },
  mounted() {
    store.getAll('notification').then(notifications => {
      this.notifications = notifications;
    });
  }
};
</script>
<style lang="scss" scoped>
.rds-notifications-container,
.rds-notifications-overlay,
.rds-notifications {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  // z-index: 3;
  overflow: hidden;
}
.rds-notifications {
  height: auto;
  max-height: 100%;
  overflow-y: auto;
}
.rds-notifications-container {
  z-index: 19;
}
.rds-notifications-overlay {
  z-index: 9;
}
.rds-notifications {
  z-index: 10;
  // pointer-events: none;
}
.rds-notification {
  z-index: 10;
  position: relative;
}
.rds-notifications > div {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.rds-notifications-container {
  height: calc(100% - 62px - 66px);
  top: 62px;
}
.rds-notifications-overlay {
  opacity: 0.76;
  background-color: #000000;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  // height: 150%;
}
// /deep/ .notification {
//   transform: translateX(0);
// }
// .swipe-removing {
//   transition: all 0.2s;
//   &.swipe-removing-left {
//     transform: translateX(-500px) !important;
//   }
//   &.swipe-removing-right {
//     transform: translateX(500px) !important;
//   }
// }
// .menu-slide-bottom-leave-to .rds-notifications-overlay,
// .menu-slide-bottom-enter-to .rds-notifications-overlay {
//   opacity: 0;
// }
</style>
